import { render, staticRenderFns } from "./UploadDocumentView.vue?vue&type=template&id=6f0a3057&"
import script from "./UploadDocumentView.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentView.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocumentView.vue?vue&type=style&index=0&id=6f0a3057&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports